/** InsCoder WANG.J 2025-09-01 B + Collage comparison section JavaScript **/

document.addEventListener('DOMContentLoaded', function() {
  // 查找所有的 collage sections
  const sections = document.querySelectorAll('.cust-collage');
  
  sections.forEach(function(section) {
    const cards = section.querySelectorAll('.cust-collage__card');
    
    if (cards.length === 0) return;
    
    // 添加滚动动画观察器
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const sectionElement = entry.target;
          const sectionCards = sectionElement.querySelectorAll('.cust-collage__card');
          
          // 为每个卡片添加动画
          sectionCards.forEach(function(card, index) {
            setTimeout(function() {
              card.classList.add('animate-in');
            }, index * 200);
          });
          
          // 停止观察已动画的section
          observer.unobserve(sectionElement);
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
    });
    
    // 开始观察section
    observer.observe(section);
  });
  
  // 添加简单的动画CSS
  const style = document.createElement('style');
  style.textContent = `
    .cust-collage__card.animate-in {
      animation: fadeInUp 0.8s ease-out forwards;
    }
  `;
  document.head.appendChild(style);
});

/** InsCoder WANG.J 2025-09-01 E + Collage comparison section JavaScript **/
